<template>
  <aside class="sidebar">
    <img v-if="crmCompany === 'Genius Money'" :src="require('img/logos/payroll/genius_logo_dark.svg')" alt="Genius logo" class="logo"/>
    <img v-if="crmCompany === 'V3 Recruitment'" :src="require('img/logos/recruitment/v3_logo_dark.svg')" alt="V3 logo" class="logo"/>
    <img v-if="crmCompany === 'Build People'" :src="require('img/logos/build_people/bp_logo.svg')" alt="BP logo" class="logo"/>
    <sidebar-menu @toggle-collapse="onToggleCollapse" :menu="menu" :collapsed="collapsed" :showOneChild="true"/>
  </aside>
</template>
<script>
import {SidebarMenu} from '../../js/sidebar/index';
import menuList from '../../js/menu';

export default {
  name: "sidebar",
  components: {
    SidebarMenu
  },
  data() {
    return {
      menu: menuList,
    }
  },
  computed: {
    collapsed() {
      return this.$store.state.sidebar.collapsed;
    }
  },
  methods: {
    onToggleCollapse(collapsed) {
      this.$store.commit('CHANGE_COLLAPSE_STATE', collapsed);
      if (!collapsed) {
        let main_content = document.getElementById('main_content_div');
        main_content.classList.add('expanded_sidebar');
      }
      else {
        let main_content = document.getElementById('main_content_div');
        main_content.classList.remove('expanded_sidebar');
      }
    }
  }
}
</script>
<style lang="scss">
.sidebar {
  .logo {
    display:    block;
    position:   fixed;
    padding:    3px;
    width:      $sb_width;
    height:     auto;
    z-index:    99;

    background: $bc_1;
  }
}
</style>
